import classNames from 'classnames';
import { useState } from 'react';
import UsersTab from './UsersTab';

import './SpaceTabs.css';

const TABS = ['USERS', 'INTEGRATIONS'];

const SpaceTabs = () => {
  const [activeTab, setActiveTab] = useState(TABS[0]);
  return (
    <div className="">
      <ul className="flex gap-8 tabs w-full border-b-6xs border-solid border-grayNickel">
        {TABS.map((tab) => (
          <li key={tab} className={classNames('tab-item text-sm', { active: activeTab === tab })}>
            <a href="#" onClick={() => setActiveTab(tab)}>
              {tab}
            </a>
          </li>
        ))}
      </ul>

      <div className="mt-4">
        {activeTab === 'USERS' && <UsersTab />}
        {activeTab === 'INTEGRATIONS' && <span>Unavailable</span>}
      </div>
    </div>
  );
};

export default SpaceTabs;
